import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  Box,
  CircularProgress,
  TextField,
  MenuItem,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';
import DoneAllOutlinedIcon from '@material-ui/icons/DoneAllOutlined';
import { RegistroMarcacion, useGestionMarcacionApi } from '../hooks/useGestionMarcacionApi';
import MarcacionesDiaPanel from './MarcacionesDiaPanel';

interface Props {
  open: boolean;
  registro: RegistroMarcacion | null;
  onClose: () => void;
  onSuccess?: () => void;
}

const motivosSupera = [
  { value: 'CP', label: 'Cubrió por falta de personal' },
  { value: 'HA', label: 'Hizo horas adicionales' },
  { value: 'CA', label: 'Corresponde asignación' },
  { value: 'CR', label: 'Corresponde Reemplazo' },
  { value: 'CO', label: 'Corresponde OS' },
];

const SuperaModal: React.FC<Props> = ({ open, registro, onClose, onSuccess }) => {
  const api = useGestionMarcacionApi();
  const [motivo, setMotivo] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [mensajeExito, setMensajeExito] = useState('');
  const [error, setError] = useState('');

  const limpiar = () => {
    setMotivo('');
    setMensajeExito('');
    setError('');
  };

  const handleClose = () => {
    if (loading) return;
    limpiar();
    onClose();
  };

  if (!registro) return null;

  const guardar = async () => {
    if (!motivo) {
      setError('Seleccioná un motivo.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const payload = {
        legajo: registro.nroLegajo,
        entrada: registro.entrada,
        salida: registro.salida,
        total: registro.total,
        fecha: registro.fecha,
        tipoHora: registro.tipoHora,
        comentario: `SUP- ${motivo}`,
        puntoServicio: registro.nombrePServicio,
        entrada_id: registro.entrada_id,
        salida_id: registro.salida_id,
      };
      const response: any = await api.guardarSupera(payload);
      if (response?.status === 200) {
        setMensajeExito(response.data.info || 'Gestión Supera guardada correctamente');
        onSuccess?.();
      } else if (response?.status === 400) {
        setError(response.data?.error || 'Error desconocido al guardar la gestión Supera.');
      } else {
        setError('No se pudo guardar la gestión Supera.');
      }
    } catch (e: any) {
      setError(e?.response?.data?.error || e?.message || 'Error al guardar la gestión Supera.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle disableTypography style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: '#900533', color: 'white' }}>
        <Typography variant="h6" style={{ color: 'white' }}>Gestión Marcación · Supera</Typography>
        <IconButton onClick={handleClose} size="small" style={{ color: 'white' }} disabled={loading}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Box display="flex" flexDirection="column" gridGap={6} marginBottom={2}>
          <Typography variant="body2"><strong>Operario:</strong> {registro.nombre}</Typography>
          <Typography variant="body2"><strong>Legajo:</strong> {registro.nroLegajo}</Typography>
          <Typography variant="body2"><strong>Punto de Servicio:</strong> {registro.nombrePServicio}</Typography>
          <Typography variant="body2"><strong>Fecha:</strong> {registro.fecha}</Typography>
          <Typography variant="body2"><strong>Entrada:</strong> {registro.entrada}</Typography>
          <Typography variant="body2"><strong>Salida:</strong> {registro.salida}</Typography>
          <Typography variant="body2"><strong>Total:</strong> {registro.total}</Typography>
        </Box>

        <MarcacionesDiaPanel
          legajo={registro.nroLegajo}
          fecha={registro.fecha}
          idMarcacionActual={registro.idMarcacion}
        />

        <TextField
          select
          fullWidth
          required
          label="Motivo"
          value={motivo}
          onChange={(e) => setMotivo(e.target.value)}
          variant="outlined"
          margin="normal"
        >
          {motivosSupera.map((opt) => (
            <MenuItem key={opt.value} value={opt.label}>{opt.label}</MenuItem>
          ))}
        </TextField>

        {mensajeExito && (
          <Box display="flex" alignItems="center" gridGap={8} marginTop={2}>
            <DoneAllOutlinedIcon style={{ color: '#900533' }} />
            <Typography style={{ color: '#900533' }}>{mensajeExito}</Typography>
          </Box>
        )}
        {error && (
          <Box marginTop={2}>
            <Typography color="error">{error}</Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>Cerrar</Button>
        <Button
          variant="contained"
          onClick={guardar}
          disabled={loading || !motivo || !!mensajeExito}
          style={{ backgroundColor: '#900533', color: 'white' }}
          startIcon={loading ? <CircularProgress size={16} style={{ color: 'white' }} /> : <SaveIcon />}
        >
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SuperaModal;
